<template>
  <div
    class="form-group lar_form_group"
    :class="{
      [`col-${cols}`]: !!cols,
      [`offset-${offset}`]: !!offset
    }"
  >
    <label
      v-if="label"
      class="form_label"
      :for="groupName"
    >
      <span class="text-danger">{{ isRequired ? '* ' : '' }}</span>{{ label }}</label>
    <slot name="form-check" />
    <slot />
    <slot name="help-text" />
    <div
      v-if="hasError"
      class="invalid-tooltip"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormGroup',
  props: {
    formCheck: {
      type: Boolean,
      default: false
    },
    groupName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    cols: {
      type: [Number, String],
      default: ''
    },
    offset: {
      type: [Number, String],
      default: ''
    },
    hasError: Boolean,
    errorMessage: {
      type: String,
      default: ''
    },
    isRequired: Boolean
  }
}
</script>
<style lang="scss" scoped>
.lar_form_group {
    .form_label {
        color: #787878;
        display: block;
        min-height: 1.6rem;
        margin-bottom: 0.5rem;
    }
}
</style>
